import { initializeApollo } from './apolloClient'
import { DocumentNode } from '@apollo/client'

interface QueryParams {
  query: DocumentNode
  variables?: Record<string, unknown>
}

const query = async ({ query, variables }: QueryParams) => {
  const apolloClient = initializeApollo()

  const { data } = await apolloClient.query({ query, variables })

  return data
}

export default query
